import React from 'react';
import { useChatButton } from '../context/ChatButtonContext';
import ChatButton from './ChatButton';

const GlobalChatButton = () => {
  const { isVisible, currentSymbol } = useChatButton();

  if (!isVisible) {
    return null;
  }

  return <ChatButton />;
};

export default GlobalChatButton;
